import { BASE_URL } from '../utils/apiUtils';
import { HttpService } from './HttpService';

export const JudgeService = () => {
	const { get, post, put } = HttpService();

	const getJudges = (size = 10, clerkId = null) => {
		const url = `${BASE_URL}/api/judge/judge/view?size=${size}&page=0`;
		return get(url, 'GetJudges', [], null, clerkId);
	};
	const getActiveJudges = async (search, page = 0, size = 10) => {
		const url = `${BASE_URL}/api/judge/active?judgeName=${search}&size=${size}&page=${page}`;
		return get(url, 'GetJudges', []);
	};
	const getJudge = (judgeId) => {
		const url = `${BASE_URL}/api/judge/judge/${judgeId}`;
		return get(url, 'GetJudge', []);
	};

	const getCourtOptions = () => {
		const url = `${BASE_URL}/api/courts?page=0&size=1000`;
		return get(url, 'GetCourts', []);
	};

	const getJudgesByCourt = (court_id) => {
		const url = `${BASE_URL}/api/judge/court/${court_id}`;
		return get(url, 'GetJudgesByCourt', []);
	};

	const createJudge = async (data) => {
		const url = `${BASE_URL}/api/judge/judge`;
		return await post(url, data, 'newJudge', {});
	};

	const getAllJudges = async () => {
		const url = `${BASE_URL}/api/judge`;
		return get(url, 'getAllJudges', []);
	};

	const handlePresidingJudgeChangeFlag = (caseId, body) => {
		const url = `${BASE_URL}/api/case/assign/update-judge-flag/${caseId}`;
		return put(url, body, 'handlePresidingJudgeChangeFlag', {});
	};

	return {
		getJudges,
		getJudge,
		getActiveJudges,
		getCourtOptions,
		getJudgesByCourt,
		getAllJudges,
		createJudge,
		handlePresidingJudgeChangeFlag
	};
};
